import { useCallback } from 'react';

import { useConditionState } from './useConditionState';
import { FieldType } from '../../types';

export const useFieldTypeState = () => {
  const {
    condition: { fieldType },
    setCondition,
  } = useConditionState();
  const setFieldType = useCallback(
    (newFieldType?: FieldType) =>
      setCondition((condition) => ({ ...condition, fieldType: newFieldType })),
    [setCondition],
  );

  return { fieldType, setFieldType };
};
